<template>
  <div class="home">
    <div class="filter-wrapper">
      <div>
        <call-input
          v-model.trim="dataSearch"
          type-input="search"
          placeholder="Search Player ID"
          :enter-icon="true"
          @input="onSearchClear($event, 'dataSearch')"
          @enter="onSearch">
          <template slot="prefix">
            <font-awesome-icon :icon="dataIconSearch" />
          </template>
        </call-input>

        <call-input
          v-model.trim="dataSearchTaskId"
          type-input="search"
          placeholder="Search Task ID"
          :enter-icon="true"
          @input="onSearchClear($event, 'dataSearchTaskId')"
          @enter="onSearchTaskId">
          <template slot="prefix">
            <font-awesome-icon :icon="dataIconSearch" />
          </template>
        </call-input>

        <v-select
          v-model="dataSelectLastDayValue"
          :options="dataSelectOptionsLastDay"
          :filterable="false"
          :searchable="false"
          :components="{ Deselect: dataComponentDeselect }"
          placeholder="All"
          :class="[
            'call-select',
            dataSelectLastDayValue ? 'call-select--value' : null
          ]"
          @input="$_ajax({ reset: true })">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
        </v-select>

        <v-select
          v-if="!computedIsOperator"
          v-model="dataSelectOperatorValue"
          :options="dataSelectOptionsOperator"
          label="name"
          :components="{ Deselect: dataComponentDeselect }"
          placeholder="All Operators"
          :class="[
            'call-select',
            dataSelectOperatorValue ? 'call-select--value' : null
          ]"
          @input="onSelectTeamsAndRole">
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes">
              <font-awesome-icon :icon="dataIconDown" />
            </span>
          </template>
          <template slot="no-options">
            Введите имя Operator
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>

        <popover
          v-model="dataShowPopover"
          trigger="click">
          <div style="padding: 16px">
            <span class="filter-wrapper__label">Status</span>
            <call-checked-closed-opened-all v-model="dataFilterOpenedClosed" />
            <span class="filter-wrapper__label">Gift</span>
            <CallCheckedClosedOpenedCustom
              v-model="dataFilterHasGift"
              :config-tab="configTab" />
            <span
              v-if="dataProjectOptions.auto_calls_available"
              class="filter-wrapper__label">Status Auto-Call</span>
            <CallAutoStatus
              v-if="dataProjectOptions.auto_calls_available"
              v-model="dataFilterTypeAutoCall" />
            <span class="filter-wrapper__label">Closed Type</span>
            <v-select
              v-model="typeClosing"
              :options="typeClosingList"
              :filterable="false"
              :searchable="false"
              :components="{ Deselect: dataComponentDeselect }"
              placeholder="All"
              style="margin-bottom: 16px"
              :class="[
                'tasks__popover-select',
                'call-select',
                typeClosing ? 'call-select--value' : null
              ]">
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes">
                  <font-awesome-icon :icon="dataIconDown" />
                </span>
              </template>
            </v-select>
            <span class="filter-wrapper__label">Result</span>
            <div
              v-for="list in filterPhone"
              :key="list.name"
              :class="{ 'is-active': list.active }"
              style="background-color: transparent;margin-bottom: 8px"
              class="call-phone-checkbox-filter">
              <input
                :id="'subscribeNews' + list.name"
                v-model="list.active"
                type="checkbox">
              <label
                class="call-phone-checkbox-filter__title"
                :for="'subscribeNews' + list.name">
                {{ list.name }}
              </label>
            </div>
            <div style="display: flex; min-width: 300px; margin-top: 16px">
              <call-button
                type="danger"
                plain
                full
                style="margin: 0px 2px"
                :icon="dataIconClose"
                @click="clickFilterCancel()">
                &nbsp;Clear Filter
              </call-button>
              <call-button
                type="success"
                full
                style="margin: 0px 2px"
                :icon="dataIconCheck"
                @click="clickFilterSend()">
                &nbsp;Filter
              </call-button>
            </div>
          </div>
          <template #reference>
            <call-button
              :icon="dataIconFilter"
              style="position: relative">
              Filter
              <call-badge
                v-if="computedFilterCount > 0"
                class="call-filter-badge"
                type="danger">
                {{ computedFilterCount }}
              </call-badge>
            </call-button>
          </template>
        </popover>
      </div>
      <div>
        <call-pagination
          :obj-pagination="dataObjPagination"
          :page-value="50"
          @on-pagination="$_ajax" />

        <call-button
          v-if="showAutoCall"
          :icon="dataProjectOptions.is_auto_call_running ? dataStop : dataPhone"
          plain
          :disabled="dataProjectOptions.is_auto_call_running"
          :type="
            dataProjectOptions.is_auto_call_running ? 'warning' : 'success'
          "
          @click="clickShowProjectSetting()">
          {{ computedTextBtnAutoCall }}
        </call-button>
        <call-button
          v-if="
            (computedIsAdmin || computedIsModerator) && computedProjectIsActive
          "
          :icon="dataAddIcon"
          type="success"
          @click="clickShowAddTask()">
          Add Tasks
        </call-button>
      </div>
    </div>
    <div class="table-wrapper">
      <b-table
        striped
        hover
        no-local-sorting
        :show-empty="isLoaded"
        :fields="computedDataMixinTaskFields"
        :items="dataTaskList"
        @sort-changed="onSortTabel"
        @row-hovered="onHover"
        @row-unhovered="onUnHover">
        <template #empty>
          <EmptyTable />
        </template>
        <!-- @row-clicked="value => onActions(value, 'view')" -->
        <template #head(selected)>
          <span :class="[isAllSelectedDisabled && 'wrap-disabled']">
            <b-form-checkbox
              :class="[isAllSelectedDisabled && 'disabled']"
              :disabled="isAllSelectedDisabled"
              :checked="isAllSelected"
              :button-checked="isAllSelected"
              :indeterminate="isIndeterminate"
              @change="onToggleSelectAll"
              @click.stop
              @mousedown.prevent />
          </span>
        </template>
        <template #cell(selected)="data">
          <span :class="[!isCheckPermissionsAllowed(data.item) && 'wrap-disabled']">
            <b-form-checkbox
              :class="[!isCheckPermissionsAllowed(data.item) && 'disabled']"
              :disabled="!isCheckPermissionsAllowed(data.item)"
              :checked="selectedTaskIds.includes(data.item.id)"
              @change="onToggleTaskSelection(data.item.id, $event)"
              @click.stop
              @mousedown.prevent />
          </span>
        </template>
        <template #head(auto_closed_free)>
          <span class="success">
            Closed
          </span>
          Free
        </template>
        <template #head(auto_closed_assigned)>
          <span class="success">
            Closed
          </span>
          Assigned
        </template>
        <template #cell(isBlocked)="data">
          <font-awesome-icon
            v-if="!data.item.closed_by"
            :icon="dataIconClock" />
          <font-awesome-icon
            v-else
            class="tabel-icon--green"
            :icon="dataSolidIconCheck" />
        </template>
        <template #cell(actions)="data">
          <call-table-tasks-actions
            v-show="data.item.actions"
            :closed="!data.item.closed_by"
            :operator="!data.item.operator_id"
            :time="!data.item.execute_before"
            @on-action="value => onActions(data.item, value)" />
        </template>
        <!-- <template #cell(player_birthday)="data">
          {{ data.item.player_birthday | dateBrithday }}
        </template> -->
        <template #cell(is_bonus_given)="data">
          <span :class="[data.item.is_bonus_given && 'success']">
            <font-awesome-icon
              :icon="data.item.is_bonus_given ? dataIconCheck : dataIconClose" />
          </span>
        </template>
        <template #cell(auto_closed_free)="data">
          <span :class="[data.item.auto_closed_free && 'success']">
            <font-awesome-icon
              :icon="data.item.auto_closed_free ? dataIconCheck : dataIconClose" />
          </span>
        </template>
        <template #cell(auto_closed_assigned)="data">
          <span :class="[data.item.auto_closed_assigned && 'success']">
            <font-awesome-icon
              :icon="
                data.item.auto_closed_assigned ? dataIconCheck : dataIconClose
              " />
          </span>
        </template>
        <template #cell(kpi)="data">
          <span :class="[data.item.kpi && 'success']">
            <font-awesome-icon
              :icon="data.item.kpi ? dataIconCheck : dataIconClose" />
          </span>
        </template>
        <template #cell(auto_call_status)="data">
          <span
            :style="{ color: dataAutoCall[data.item.auto_call_status].color }">
            <font-awesome-icon
              :icon="dataAutoCall[data.item.auto_call_status].icon" />
          </span>
        </template>
        <template #cell(execute_before)="data">
          <call-badge-table
            v-if="data.item.execute_before"
            :type="
              methodTypeScheduled(data.item.execute_before, data.item.closed_by)
            ">
            {{ data.item.execute_before | dateFilter }}
          </call-badge-table>
        </template>
        <template #cell(comment_count)="data">
          {{ data.item.comment_count }}
          <font-awesome-icon
            :class="
              data.item.comment_count > 0
                ? 'tabel-icon--green'
                : 'tabel-icon--white'
            "
            :icon="data.item.comment_count > 0
              ? dataSolidIconComment : dataIconComment" />
        </template>
        <template #cell(created_at)="data">
          {{ data.item.created_at | dateFilter }}
        </template>
      </b-table>
    </div>
    <call-modal-add-tasks
      v-model="dataShowAddTask"
      :project-id="computedProjectId"
      @on-update="$_ajax" />
    <call-modal-add-tasks
      v-model="dataShowProjectSetting"
      :project-id="computedProjectId"
      @on-update="$_ajax" />
    <call-re-assign
      v-model="dataShowReAssign"
      :title="dataModalTitle"
      :team-id="computedProjectTeamId"
      :task-id="dataIdUpdateTask"
      :operator-id="dataModalOption"
      @on-update="$_ajax" />
    <call-re-sheduled
      v-model="dataShowReSchedule"
      :title="dataModalTitle"
      :task-id="dataIdUpdateTask"
      :time-schedule="dataModalOption"
      @on-update="$_ajax" />
    <call-close-task
      v-model="dataShowCloseTask"
      :task-id="dataIdUpdateTask"
      @on-update="$_ajax" />

    <CallUpdateProjectSettings
      v-model="dataShowProjectSetting"
      :project-id="computedProjectId"
      :project-data="dataProjectOptions"
      :data-auto-call-projects-settings="dataAutoCallProjectsSettings"
      @on-update="updateAfterSetSetting" />

    <CallUpdateNameProject
      v-model="isOpenModalName"
      @on-update="handlerRename" />

    <ToastCallTasks
      v-if="selectedTaskIds.length"
      :selected-task-ids="selectedTaskIds"
      @on-start="clickShowProjectSetting('custom')"
      @on-cancel="resetCallSelected" />
  </div>
</template>

<script>
import { BTable, BFormCheckbox } from 'bootstrap-vue';
import {
  faPhone,
  faStop,
  faCheck,
  faClock,
  faComments,
  faFilter,
  faPlus,
  faSearch,
  faTimes,
  faList
  , faClock as farClock
} from '@fortawesome/pro-regular-svg-icons';

import { faComments as fasComments, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import CallUpdateNameProject from '@/components/common/modals/CallUpdateNameProject';

import CallInput from '../../../components/common/CallInput';
import ToastCallTasks from '../../../components/common/ToastCallTasks.vue';
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import CallPagination from '../../../components/desktop/CallPagination';
import taskTable from '../../../mixins/table/taskTable';
import {
  PROJECTS_GET,
  TASKS_GET_ALL,
  USERS_GET_ALL,
  AUTOCALL_CUSTOM
} from '../../../store/types/actions.types';
import helper from '../../../service/helper';
import selectOperators from '../../../mixins/select/selectOperators';
import CallCheckedClosedOpenedAll from '../../../components/common/CallCheckedClosedOpenedAll';
import CallAutoStatus from '../../../components/common/CallAutoStatus.vue';
import CallBadgeTable from '../../../components/common/CallBadgeTable';
import CallTableTasksActions from '../../../components/desktop/CallTableTasksActions';
import CallReSheduled from '../../../components/common/modals/CallReSheduled';
import CallCloseTask from '../../../components/common/modals/CallCloseTask';
import CallReAssign from '../../../components/common/modals/CallReAssign';
import { ID_ROLE_OPERATOR } from '../../../service/consts';
import CallModalAddTasks from '../../../components/common/modals/CallAddTasks';
import CallButton from '../../../components/common/CallButton';
import Popover from 'vant/lib/popover';
import 'vant/lib/popover/style';
import CallBadge from '@/components/common/CallBadge';
import { SET_ALL } from '@/store/types/mutations.types';
import selectTasksPeriod from '../../../mixins/select/selectTasksPeriod';
import CallUpdateProjectSettings from '../../../components/common/modals/CallUpdateProjectSettings';
import CallCheckedClosedOpenedCustom from '../../../components/common/CallCheckedClosedOpenedCustom';

const _currentDate = Date.now();

export default {
  name: 'PageTask',
  components: {
    CallUpdateProjectSettings,
    CallBadge,
    CallButton,
    CallModalAddTasks,
    CallReAssign,
    CallCloseTask,
    CallReSheduled,
    CallTableTasksActions,
    CallBadgeTable,
    CallCheckedClosedOpenedAll,
    CallPagination,
    CallInput,
    BTable,
    Popover,
    BFormCheckbox,
    ToastCallTasks,
    CallAutoStatus,
    CallCheckedClosedOpenedCustom,
    CallUpdateNameProject
  },
  mixins: [taskTable, selectOperators, selectTasksPeriod],
  data () {
    return {
      dataPhone: faPhone,
      dataStop: faStop,
      dataAddIcon: faPlus,
      dataIconSearch: faSearch,
      dataIconClock: faClock,
      dataIconCheck: faCheck,
      dataSolidIconCheck: faCheckCircle,
      dataIconComment: faComments,
      dataSolidIconComment: fasComments,
      dataIconFilter: faFilter,
      dataShowAddTask: false,
      dataShowProjectSetting: false,
      dataShowUpdateTask: false,
      dataIdUpdateTask: null,
      dataShowReSchedule: false,
      dataShowReAssign: false,
      dataShowCloseTask: false,
      dataShowPopover: false,
      dataIconClose: faTimes,
      dataIconList: faList,
      filterPhone: [
        {
          active: false,
          name: 'Successful',
          key: 'success'
        },
        {
          active: false,
          name: 'Cancelled',
          key: 'cancelled'
        },
        {
          active: false,
          name: 'No Answer',
          key: 'noanswer'
        },
        {
          active: false,
          name: 'Rejected',
          key: 'rejected'
        }
      ],
      dataModalOption: null,
      dataModalTitle: null,
      dataFilterOpenedClosed: null,
      dataFilterHasGift: 'all_gift',
      dataFilterTypeAutoCall: null,
      dataTaskList: [],
      selectedTaskIds: [],
      dataSearch: null,
      dataSearchTaskId: null,
      dataDesc: null,
      dataOrderBy: null,
      dataProjectOptions: {},
      dataProjectPermissions: {},
      dataObjPagination: {},
      dataObjPermissions: {},
      typeClosing: null,
      typeClosingList: [
        {
          key: null,
          label: 'All'
        },
        {
          key: 'auto_closed_free',
          label: 'Auto Closed Free'
        },
        {
          key: 'auto_closed_assigned',
          label: 'Auto Closed Assigned'
        },
        {
          key: 'kpi',
          label: 'KPI'
        }
      ],
      dataAutoCall: {
        none: {
          name: 'none',
          color: '#222222',
          icon: faTimes
        },
        complete: {
          name: 'complete',
          color: '#20a052',
          icon: faCheck
        },
        running: {
          name: 'running',
          color: '#e96c2c',
          icon: farClock
        }
      },
      isLoaded: false,
      isOpenModalName: false,
      dataAutoCallProjectsSettings: {
        type: 'main',
        selectedTaskIds: []
      },
      configTab: [
        {
          name: 'All',
          action: 'all_gift'
        },
        {
          name: 'Issued',
          action: 'issued'
        },
        {
          name: 'Not Issued',
          action: 'not_issued'
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      computedIsAdmin: 'auth/isAdmin',
      computedIsOperator: 'auth/isOperator',
      computedIsModerator: 'auth/isModerator',
      computedCurrentUser: 'auth/currentUser'
    }),

    computedTextBtnAutoCall () {
      if (this.dataProjectOptions.is_auto_call_running) return 'Auto Call Running';
      if (this.dataProjectPermissions.auto_call_run_create_allowed) return 'Start Auto Calls';
      if (this.dataProjectPermissions.auto_call_run_update_allowed) return 'Edit Auto Calls';
      return 'Start Auto Calls';
    },

    showAutoCall () {
      return (
        (this.computedIsAdmin || this.computedIsModerator) &&
        this.dataProjectOptions?.auto_calls_available &&
        !!this.dataTaskList.length
      );
    },

    computedDataMixinTaskFields () {
      return this.dataMixinTaskFields.filter(field => {
        if (!this.showAutoCall && field.key === 'selected') {
          return false;
        }
        if (!this.dataProjectOptions?.auto_calls_available && field.key === 'auto_call_status') {
          return false;
        }

        return true;
      });
    },

    isAllSelected () {
      return (
        this.dataTaskList.filter(item => this.isCheckPermissionsAllowed(item))
          .length &&
        this.dataTaskList
          .filter(item => this.isCheckPermissionsAllowed(item))
          .every(item => this.selectedTaskIds.includes(item.id))
      );
    },

    isAllSelectedDisabled () {
      return (
        this.dataTaskList.filter(item => this.isCheckPermissionsAllowed(item))
          .length === 0
      );
    },

    isIndeterminate () {
      const pageSelected = this.dataTaskList
        .filter(item => this.isCheckPermissionsAllowed(item))
        .filter(item => this.selectedTaskIds.includes(item.id)).length;

      return (
        pageSelected > 0 &&
        pageSelected <
          this.dataTaskList.filter(item => this.isCheckPermissionsAllowed(item))
            .length
      );
    },
    computedFilterCount () {
      const closedFilterEnabed = this.typeClosing ? 1 : 0;
      const tabFilterEnabled = this.dataFilterOpenedClosed ? 1 : 0;
      const tabFilterHasGift = this.dataFilterHasGift !== 'all_gift' ? 1 : 0;
      const tabCallFilterEnabled = this.dataFilterTypeAutoCall ? 1 : 0;
      return (
        this.filterPhone.filter(item => item.active).length +
        tabFilterEnabled +
        closedFilterEnabed +
        tabCallFilterEnabled +
        tabFilterHasGift
      );
    },
    computedProjectId () {
      return this.$route.params?.projectId;
    },
    computedProjectIsActive () {
      // eslint-disable-next-line camelcase
      return this.dataProjectOptions?.is_active;
    },
    computedProjectTeamId () {
      // eslint-disable-next-line camelcase
      return this.dataProjectOptions?.team_id;
    },
    computedIsVip () {
      return this.dataProjectOptions?.vip;
    },
    computedDataFilterHasGift () {
      if (this.dataFilterHasGift === 'issued') {
        return true;
      }
      if (this.dataFilterHasGift === 'not_issued') {
        return false;
      }
      return undefined;
    }
  },

  async created () {
    this.isLoaded = false;
    this.$_ajax = ((options = {}) => {
      let _page = 0;
      let _limit = 50;

      const { currentRoute: { name: pageName } = {} } = this.$router;

      const _filterKey = `_filter${pageName}`;

      if (!helper.isEmpty(this.$route.query, _filterKey)) {
        try {
          options = helper.clearObject(
            JSON.parse(this.$route.query[_filterKey])
          );

          const _arrFilter = [
            'type',
            'operator_ids',
            'search_task_id',
            'search',
            'desc',
            'orderBy',
            'limit',
            'page',
            'call_statuses',
            'period',
            'closing_type',
            'has_bonus'
          ];

          for (const _key of _arrFilter) {
            if (!helper.isEmpty(options, _key)) {
              switch (_key) {
                case 'has_bonus':
                  this.dataFilterHasGift = options[_key];
                  break;
                case 'type':
                  this.dataFilterOpenedClosed = options[_key];
                  break;
                case 'auto_call_statuses':
                  this.dataFilterTypeAutoCall = options[_key];
                  break;
                case 'search':
                  this.dataSearch = options[_key];
                  break;
                case 'search_task_id':
                  this.dataSearchTaskId = options[_key];
                  break;
                case 'operator_ids':
                  this.dataSelectOperatorValue = options[_key];
                  break;
                case 'desc':
                  this.dataDesc = options[_key];
                  break;
                case 'orderBy':
                  this.dataOrderBy = options[_key];
                  break;
                case 'limit':
                  _limit = options[_key];
                  break;
                case 'page':
                  _page = options[_key];
                  break;
                case 'call_statuses':
                  this.filterPhone = options[_key];
                  break;
                case 'period':
                  this.dataSelectLastDayValue = options[_key];
                  break;
                case 'closing_type':
                  this.typeClosing = options[_key];
                  break;
              }
            }
          }
        } catch (e) {
          console.log('Error query params');
        }
      }

      return async ({
        search = this.dataSearch,
        search_id = this.dataSearchTaskId,
        desc = this.dataDesc,
        orderBy = this.dataOrderBy,
        limit = null,
        page = null,
        reset = false
      } = options) => {
        this.$store.dispatch('loading/startLoading');

        try {
          if (!this.dataSelectLastDayValue) {
            this.dataSelectLastDayValue = {
              ...this.dataSelectLastDayValueDefault
            };
          }

          if (!helper.isEmpty(page) && page !== _page) {
            _page = page;
          }

          if (!helper.isEmpty(limit) && limit !== _limit) {
            _limit = limit;
          }

          if (reset) {
            _page = 0;
          }

          const {
            payload: { list = [] },
            misc: { paging = {}, permissions = {} }
          } = await this.$store.dispatch(`task/${TASKS_GET_ALL}`, {
            params: {
              project_ids: [this.computedProjectId],
              search,
              search_id,

              ...(this.dataSelectOperatorValue?.id === 'without_operator'
                ? { without_operator: true }
                : {
                    operator_ids: this.computedIsOperator
                      ? [this.computedCurrentUser?.id]
                      : [this.dataSelectOperatorValue?.id]
                  }),
              type: this.dataFilterOpenedClosed,
              has_bonus: this.computedDataFilterHasGift,
              auto_call_statuses: [this.dataFilterTypeAutoCall],
              desc,
              order_by: orderBy,
              limit: _limit,
              page: _page,
              call_statuses: this.filterPhone.reduce((itemA, itemB) => {
                if (itemB.active) {
                  itemA.push(itemB.key);
                }
                return itemA;
              }, []),
              period: this.dataSelectLastDayValue?.key,
              closing_type: this.typeClosing?.key
            }
          });
          this.isLoaded = true;
          this.dataObjPagination = paging;
          this.dataObjPermissions = permissions;
          this.dataTaskList = list.map(item => {
            item.actions = false;
            return item;
          });

          this.$router
            .replace({
              ...this.$router.currentRoute,
              query: {
                ...(this.$route.query || {}),
                [_filterKey]: JSON.stringify(
                  helper.clearObject({
                    type: this.dataFilterOpenedClosed,
                    has_bonus: this.dataFilterHasGift,
                    auto_call_statuses: this.dataFilterTypeAutoCall,
                    operator_ids: this.dataSelectOperatorValue,
                    search,
                    search_task_id: this.dataSearchTaskId,
                    desc,
                    orderBy,
                    limit: _limit,
                    page: _page,
                    call_statuses: this.filterPhone,
                    period: this.dataSelectLastDayValue,
                    closing_type: this.typeClosing
                  })
                ),
                isVip: this.computedIsVip
              }
            })
            .catch(() => {});

          options = {};
        } finally {
          this.$store.dispatch('loading/stopLoading');
        }
      };
    })();

    this.$store.dispatch('loading/startLoading');
    await this.getProjectOptions();
    this.$store.dispatch('loading/stopLoading');

    this.$nextTick(async _ => {
      const {
        payload: { list: listUser = [] }
      } = await this.$store.dispatch(`user/${USERS_GET_ALL}`, {
        params: {
          team_ids: [this.computedProjectTeamId],
          role: ID_ROLE_OPERATOR,
          short: true
        }
      });

      this.dataSelectOptionsOperator = [
        ...listUser,
        { id: 'without_operator', name: 'Without operator' }
      ];
      this.$router
        .replace({
          ...this.$router.currentRoute,
          query: {
            ...(this.$route.query || {}),
            isVip: this.computedIsVip
          }
        })
        .catch(() => {});
    });
  },

  mounted () {
    if (helper.isEmpty(this.$route.params?.projectId)) {
      this.$router.go(-1);
    }

    this.$root.$on('clickEditProjectNameIcon', (item) => {
      this.isOpenModalName = true;
    });
  },

  destroyed () {
    this.$root.$off('clickEditProjectNameIcon');
  },

  methods: {
    handlerRename () {
      this.$_ajax({ reset: true });
      this.isOpenModalName = false;
    },

    isCheckPermissionsAllowed (item) {
      if (this.dataObjPermissions[item.id]?.auto_call_create_allowed === undefined) {
        return false;
      }
      return this.dataObjPermissions[item.id].auto_call_create_allowed;
    },

    resetCallSelected () {
      this.selectedTaskIds = [];
    },

    async setTaskCalled () {
      if (!this.isLoaded) return;
      this.isLoaded = false;
      try {
        const params = { task_ids: this.selectedTaskIds };

        await this.$store.dispatch(`autocall/${AUTOCALL_CUSTOM}`, {
          params,
          context: this
        });
        this.resetCallSelected();
        this.isLoaded = true;
      } catch (e) {
        this.isLoaded = true;
        this.$_ajax({ reset: true });
        throw Error(e);
      }
    },

    onToggleTaskSelection (taskId, checked) {
      const exists = this.selectedTaskIds.includes(taskId);

      if (checked && !exists) {
        this.selectedTaskIds.push(taskId);
      } else if (!checked && exists) {
        this.selectedTaskIds = this.selectedTaskIds.filter(id => id !== taskId);
      }
    },
    onToggleSelectAll (checked) {
      const pageIds = this.dataTaskList
        .filter(item => this.isCheckPermissionsAllowed(item))
        .map(item => item.id);

      if (checked) {
        this.selectedTaskIds = [
          ...new Set([...this.selectedTaskIds, ...pageIds])
        ];
      } else {
        this.selectedTaskIds = this.selectedTaskIds.filter(
          id => !pageIds.includes(id)
        );
      }
    },

    updateAfterSetSetting () {
      this.getProjectOptions();
      this.resetCallSelected();
    },

    async getProjectOptions () {
      const [{ payload = {}, misc = {} }] = await Promise.all([
        this.$store.dispatch(`project/${PROJECTS_GET}`, {
          projectId: this.computedProjectId
        }),
        this.$_ajax()
      ]);

      this.dataProjectPermissions = misc.permissions;
      this.dataProjectOptions = payload?.project;
    },

    clickFilterSend () {
      this.$store.commit(`mobile/${SET_ALL}`, {
        data: this.filterPhone,
        key: 'filterPhone'
      });
      this.dataShowPopover = false;
      this.$_ajax({ reset: true });
    },
    clickFilterCancel () {
      this.dataFilterOpenedClosed = null;
      this.dataFilterTypeAutoCall = null;
      this.dataFilterHasGift = 'all_gift';
      this.typeClosing = null;
      this.filterPhone = this.filterPhone.map(item => {
        item.active = false;
        return item;
      });
      this.dataShowPopover = false;
      this.$_ajax({ reset: true });
    },
    clickShowAddTask () {
      this.dataShowAddTask = true;
    },
    clickShowProjectSetting (type = 'main') {
      if (type === 'custom') {
        this.dataAutoCallProjectsSettings = {
          type,
          selectedTaskIds: this.selectedTaskIds
        };
      } else {
        this.dataAutoCallProjectsSettings = {
          type,
          selectedTaskIds: []
        };
      }
      this.dataShowProjectSetting = true;
    },
    onSortTabel ({ sortBy, sortDesc }) {
      this.dataDesc = sortDesc;
      this.dataOrderBy = sortBy;
      this.$_ajax();
    },
    onSearchClear (e, flag) {
      const { currentRoute: { name: pageName } = {} } = this.$router;
      const _filterKey = `_filter${pageName}`;

      const { search = '', search_task_id = '' } = JSON.parse(
        this.$route.query[_filterKey]
      );
      if (
        (flag === 'dataSearch' && search && !this.dataSearch) ||
        (flag === 'dataSearchTaskId' &&
          search_task_id &&
          !this.dataSearchTaskId)
      ) {
        this.$_ajax({ reset: true });
      }
    },

    onSearch: debounce(function () {
      this.$_ajax({ reset: true });
    }, 1 /* 500 */),

    onSearchTaskId: debounce(function () {
      this.$_ajax({ reset: true });
    }, 1 /* 500 */),
    onSelectTeamsAndRole () {
      this.$_ajax({ reset: true });
    },
    onActions (
      {
        id: taskId,
        is_blocked: isBlocked,
        execute_before: executeBefore,
        operator_id: operatorId = null,
        player_id: playerId = 0
      },
      action
    ) {
      this.dataIdUpdateTask = taskId;
      switch (action) {
        case 're-asigned':
          this.dataModalTitle = helper.isEmpty(operatorId)
            ? 'Assign'
            : 'Re Assign';
          this.dataModalOption = operatorId;
          this.dataShowReAssign = true;
          break;
        case 're-sheduled':
          this.dataModalTitle = helper.isEmpty(executeBefore)
            ? 'Schedule'
            : 'Re Schedule';
          this.dataModalOption = executeBefore;
          this.dataShowReSchedule = true;
          break;
        case 'view':
          this.$router.push({
            name: 'ProjectTasksDetail',
            params: {
              taskId,
              projectId: this.computedProjectId
            },
            query: {
              ...(this.$route.query || {}),
              taskName: 'ID: ' + playerId
            }
          });
          break;
        case 'closed':
          this.dataShowCloseTask = true;
          break;
      }
    },
    methodTypeScheduled (date, closed) {
      if (!closed) {
        if (_currentDate > +new Date(date)) {
          return 'danger';
        } else if (_currentDate + 3600 * 24 * 2 * 1000 < +new Date(date)) {
          return 'success';
        } else {
          return 'warning';
        }
      } else {
        return 'success';
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.wrap-disabled {
  cursor: not-allowed;
}
::v-deep {
  .custom-control.custom-checkbox.disabled {
    pointer-events: none;
  }
}
</style>
